module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-300.b871ad6.woff2";